module.exports = __webpack_public_path__ + "img/finger.7ae532a0.svg";